import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from './environment.service';

@Injectable({
  providedIn: 'root',
})
export class IncidentService {

  _uri = `${this.environment.incidentBaseUrl}incident`;

  submitIncident(request) {
    return this.http.post<any>(`${this._uri}/submitincident`, request);
  }
// http://localhost:8080/incident/api/incident/submitincident
  constructor(private http: HttpClient, public environment: EnvService) {}

  getMyIncidents(request) {
    return this.http.post<any>(`${this._uri}/myincident`, request);
  }

  getAssignedIncidents(request) {
    return this.http.post<any>(`${this._uri}/assignedincident`, request);
  }

  getIncidentActions(request) {
    return this.http.post<any>(`${this._uri}/myactions`, request);
  }

  getInvestigatorsList(request) {
    return this.http.post<any>(`${this._uri}/investigatorlist`, request);
  }
  getAdminsList(request) {
    return this.http.post<any>(`${this._uri}/admin/list`, request);
  }
  rejectincident(request) {
    return this.http.post<any>(`${this._uri}/reject`, request);
  }
  getAdminDetails() {
    return this.http.get<any>(`${this._uri}/adminDetails`);
  }
  downloadReport(request: any){
    return this.http.post<any>(`${this.environment.incidentBaseUrl}audits/downloadpdf`, request);
  }
  getIMReport(request: any){
    return this.http.post<any>(`${this.environment.incidentBaseUrl}audits/getpdfincident`, request);
  }
  
}
